import React, { useCallback, useEffect } from 'react'
import ReactJson from 'react-json-view'
import { get, isNil } from 'lodash'
import PropTypes from 'prop-types'

import { INGREDIENT_SPECIAL_CASE_DEFINITION_DEFAULT_VALUES } from '../../constants'

const IngredientSpecialCaseJsonEditor = ({
  isNew,
  form,
  name,
  value,
  onChange,
  disabled,
}) => {
  const { setFields, getFieldValue } = form
  const type = getFieldValue('type')

  const handleOnChange = useCallback(
    item => {
      onChange(item.updated_src)
    },
    [onChange],
  )

  useEffect(() => {
    if (isNew && !isNil(type)) {
      setFields([
        {
          name,
          value: get(INGREDIENT_SPECIAL_CASE_DEFINITION_DEFAULT_VALUES, type),
        },
      ])
    }
  }, [isNew, name, setFields, type])

  return (
    <ReactJson
      onAdd={!disabled ? handleOnChange : undefined}
      onDelete={!disabled ? handleOnChange : undefined}
      onEdit={!disabled ? handleOnChange : undefined}
      name={null}
      src={value}
    />
  )
}

IngredientSpecialCaseJsonEditor.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func,
  isNew: PropTypes.bool.isRequired,
  form: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
}

IngredientSpecialCaseJsonEditor.defaultProps = {
  value: {},
  onChange: undefined,
  disabled: false,
}

export default IngredientSpecialCaseJsonEditor
